import Signup from "../components/Signup";
import Login from "../components/Login";
import { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { firebaseAuth } from "../utils/firebase-config";

const AuthPage = () => {
  const [signup, setSignup] = useState(true);
  const [isLogin, setIsLogin] = useState(false);
  const [loading, setLoading] = useState(true);

  const email = localStorage.getItem("email");
  function changeToLogin() {
    setSignup(false);
  }
  function changeToSignup() {
    setSignup(true);
  }

  function signOff() {
    signOut(firebaseAuth);
    localStorage.removeItem("userId");
    localStorage.removeItem("email");
    setIsLogin(false);
    // localStorage.removeItem('subscribe')
  }

  useEffect(() => {
    onAuthStateChanged(firebaseAuth, (currentUser) => {
      if (currentUser) {
        setIsLogin(true);
      } else {
        setIsLogin(false);
      }
      setLoading(false);
    });
  }, []);

  return (
    <div className="flex min-h-screen pt-16">
      {/* Left: Form Panel */}
      <div className="w-full lg:w-1/2 bg-gray-50 flex justify-center items-start lg:items-center px-6 py-10 overflow-y-auto">
        {loading ? (
          <div className="flex flex-col items-center gap-4">
            <div className="w-12 h-12 border-4 border-primary-100 border-t-primary-500 rounded-full animate-spin"></div>
            <p className="text-gray-400 text-sm font-medium">Loading...</p>
          </div>
        ) : isLogin === false ? (
          <div className="w-full max-w-md">
            {signup && (
              <Signup changeToLogin={changeToLogin} setIsLogin={setIsLogin} />
            )}
            {!signup && (
              <Login changeToSignup={changeToSignup} setIsLogin={setIsLogin} />
            )}
          </div>
        ) : (
          <div className="flex flex-col items-center text-center gap-6 max-w-xs">
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center shadow-lg">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-2">Congratulations!</h2>
              <p className="text-gray-500 text-base">You have successfully joined Wam Bam.</p>
            </div>
            <button
              type="button"
              className="bg-[#4070f4] hover:bg-[#2d5ce8] text-white font-semibold py-2.5 px-6 rounded-lg w-full transition-colors duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#4070f4] focus:ring-offset-2"
              onClick={() => signOff()}
            >
              Sign Out
            </button>
          </div>
        )}
      </div>

      {/* Right: Brand Panel */}
      <div className="hidden lg:flex lg:w-1/2 bg-primary-500 flex-col justify-center items-start px-16 relative overflow-hidden min-h-full">
        {/* Decorative circles */}
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white/5 rounded-full pointer-events-none"></div>
        <div className="absolute -bottom-32 -left-16 w-[28rem] h-[28rem] bg-white/5 rounded-full pointer-events-none"></div>
        <div className="absolute top-1/2 right-12 w-48 h-48 bg-white/5 rounded-full pointer-events-none"></div>

        <div className="relative z-10 max-w-lg">
          <div className="flex items-center gap-3 mb-10">
            <img
              src="./../../images/logo.png"
              className="w-11 h-11 object-contain"
              alt="Wam Bam Logo"
            />
            <span className="text-white/75 text-lg font-semibold tracking-wide">Wam Bam</span>
          </div>

          <h1 className="text-5xl xl:text-[3.5rem] font-extrabold text-white leading-tight mb-5">
            Your Merchant<br />Portal Awaits
          </h1>
          <p className="text-primary-100 text-lg leading-relaxed mb-10">
            Connect your POS system and start managing your business effortlessly.
          </p>

          <div className="flex flex-col gap-4">
            {[
              "Quick onboarding in minutes",
              "Seamless POS integration",
              "Secure & reliable platform",
            ].map((feature) => (
              <div key={feature} className="flex items-center gap-3">
                <div className="w-5 h-5 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <span className="text-primary-100 text-sm font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
